import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, Map, Sparkles, Droplets, Camera, LayoutTemplate, Rocket, ChevronDown, FileSpreadsheet } from 'lucide-react';
const chapters = [{
  icon: <BookOpen className="w-6 h-6" data-id="element-207" />,
  title: 'Capítulo 1: Introducción Magnética',
  content: "Aprende qué es un 'Regalo de Alto Valor Percibido' y por qué el cerebro humano paga $65 por algo que costó $12 — y cómo tú puedes capitalizar esto éticamente esta semana."
}, {
  icon: <Map className="w-6 h-6" data-id="element-208" />,
  title: 'Capítulo 2: La Ruta Secreta de Compras',
  content: 'Tu guía milimétrica de exactamente qué buscar en Dollar Tree, 5 Below, Hobby Lobby y Bath & Body Works. Incluye:\n• Lista específica de productos por sección\n• Estrategias para ofertas (buy 3 get 3)\n• El orden perfecto de visitas\n• Qué NO comprar aunque parezca tentador'
}, {
  icon: <Droplets className="w-6 h-6" data-id="element-209" />,
  title: "Capítulo 3: Proyecto 1 — 'Serenidad en Caja'",
  content: "El Kit de Spa que parece de resort de $500/noche. Paso a paso de 15 minutos con:\n• Técnica del 'nido de papel de seda'\n• La regla de las alturas para organizar\n• El truco del moño asimétrico\n• Guía de fotografía para redes"
}, {
  icon: <Sparkles className="w-6 h-6" data-id="element-210" />,
  title: "Capítulo 4: Proyecto 2 — 'Elixir de Rosas & Terciopelo'",
  content: 'La Colección de Fragancia usando Bath & Body Works que parece de $80. Incluye:\n• Guía de aromas que más venden en Mayo\n• El truco del listón doble\n• Copywriting aspiracional para etiquetas\n• Cómo el logo de B&BW hace el 40% del trabajo'
}, {
  icon: <Camera className="w-6 h-6" data-id="element-211" />,
  title: "Capítulo 5: Proyecto 3 — 'Glow & Go'",
  content: 'El Kit de Belleza Express con rodillo de jade que se vende solo. Incluye:\n• Psicología del diseño visual editorial\n• Composición fotográfica irresistible\n• El valor agregado gratis\n• Instrucciones de uso que añaden valor'
}, {
  icon: <LayoutTemplate className="w-6 h-6" data-id="element-212" />,
  title: 'Capítulo 6: Sistema de Plantillas',
  content: 'Las 3 herramientas de control que separan a una emprendedora amateur de una profesional.'
}, {
  icon: <Rocket className="w-6 h-6" data-id="element-213" />,
  title: 'Capítulo 7: Plan de Acción de 48 Horas',
  content: 'Porque información sin acción es solo entretenimiento. Este capítulo te pone en movimiento hoy.'
}];
const templates = [{
  title: 'Plantilla 1: Lista de Compras Maestra',
  desc: 'Nunca más llegues a una tienda sin saber exactamente qué buscar. Lista organizada por tienda, con casillas de verificación, columnas de precio y espacio para notas de campo.'
}, {
  title: 'Plantilla 2: Calculadora de Gastos y Ganancias',
  desc: 'Tu hoja de cálculo sin Excel. Calcula automáticamente tu costo por kit, ganancia bruta, margen porcentual, punto de equilibrio y proyección de ingresos para todo Mayo. Si no mides, no creces.'
}, {
  title: 'Plantilla 3: Control de Ventas',
  desc: 'Rastrea cada venta, cada cliente, cada canal. Descubre qué kit se vende más, qué día vende mejor y quiénes son tus clientes recurrentes — la base de datos de oro de tu negocio.'
}];
export function ProductDetails() {
  const [openChapter, setOpenChapter] = useState<number | null>(0);
  return <section className="py-24 bg-cream-50" data-id="element-214">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
        <div className="text-center mb-16" data-id="element-216">
          <h2 className="text-3xl md:text-5xl font-bold text-ink-900 mb-4" data-id="element-217">
            ¿QUÉ INCLUYE EXACTAMENTE?
          </h2>
          <div className="w-24 h-1 bg-emerald-900 mx-auto" data-id="element-218"></div>
        </div>

        {/* Ebook Section */}
        <div className="mb-16" data-id="element-219">
          <div className="flex items-center justify-between mb-8 border-b border-blush-200 pb-4" data-id="element-220">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-ink-900 flex items-center" data-id="element-221">
              <BookOpen className="w-8 h-8 mr-3 text-gold-500" data-id="element-222" />
              EL EBOOK COMPLETO
            </h3>
            <span className="text-emerald-900 font-bold bg-emerald-900/10 px-3 py-1 rounded-full text-sm" data-id="element-223">
              Valor: $47
            </span>
          </div>

          <p className="text-lg text-ink-800 mb-8 font-medium" data-id="element-224">
            7 capítulos cargados de estrategia, paso a paso visual y mentalidad
            emprendedora:
          </p>

          <div className="space-y-4" data-id="element-225">
            {chapters.map((chapter, idx) => <div key={idx} className="border border-blush-200 rounded-xl bg-white overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-226">
                <button onClick={() => setOpenChapter(openChapter === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-227">
                  <div className="flex items-center space-x-4" data-id="element-228">
                    <div className={`p-2 rounded-lg ${openChapter === idx ? 'bg-emerald-900 text-white' : 'bg-blush-50 text-emerald-900'}`} data-id="element-229">
                      {chapter.icon}
                    </div>
                    <span className="font-bold text-lg text-ink-900" data-id="element-230">
                      {chapter.title}
                    </span>
                  </div>
                  <ChevronDown className={`w-5 h-5 text-ink-800 transition-transform duration-300 ${openChapter === idx ? 'rotate-180' : ''}`} data-id="element-231" />
                </button>

                <AnimatePresence data-id="element-232">
                  {openChapter === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-233">
                      <div className="p-5 pt-0 pl-16 text-ink-800 whitespace-pre-line leading-relaxed" data-id="element-234">
                        {chapter.content}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>

        {/* Templates Section */}
        <div data-id="element-235">
          <div className="flex items-center justify-between mb-8 border-b border-blush-200 pb-4" data-id="element-236">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-ink-900 flex items-center" data-id="element-237">
              <FileSpreadsheet className="w-8 h-8 mr-3 text-gold-500" data-id="element-238" />
              LAS 3 PLANTILLAS DESCARGABLES
            </h3>
            <span className="text-emerald-900 font-bold bg-emerald-900/10 px-3 py-1 rounded-full text-sm" data-id="element-239">
              Valor: $27
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-240">
            {templates.map((template, idx) => <motion.div key={idx} whileHover={{
            y: -5
          }} className="bg-white p-6 rounded-xl border border-blush-200 shadow-sm relative overflow-hidden group" data-id="element-241">
                <div className="absolute top-0 left-0 w-full h-1 bg-gold-400 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-242"></div>
                <h4 className="font-bold text-lg text-emerald-900 mb-3" data-id="element-243">
                  {template.title}
                </h4>
                <p className="text-ink-800 text-sm leading-relaxed" data-id="element-244">
                  {template.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}